import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { CheckCircle, X } from 'lucide-react';
import './SuccessNotification.scss';

interface SuccessNotificationProps {
  message: string;
  onClose: () => void;
  duration?: number;
}

const SuccessNotification: React.FC<SuccessNotificationProps> = ({
  message,
  onClose,
  duration = 3000
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const content = (
    <div className="success-notification-overlay">
      <div className="success-notification">
        <div className="success-notification-content">
          <CheckCircle size={24} className="success-icon" />
          <span className="success-message">{message}</span>
        </div>
        <button className="close-button" onClick={onClose}>
          <X size={20} />
        </button>
      </div>
    </div>
  );

  return ReactDOM.createPortal(content, document.body);
};

export default SuccessNotification;

